/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["select-roles-modal{display:block}select-roles-modal .mat-list-text{text-transform:capitalize}"];
export { styles as styles };
